
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "assess",
})

export default class assess extends Vue {
	
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
	let pageNum = 1;
	let pageSize = 10;
    let paramter = {
		pageNum,
		pageSize
    };
    this.$http.get("producteval/list", {paramter}).then((res: any) => {
    	datas = res.data.data.data;
    	this.tableData = datas;
		// console.log("品测内容",this.tableData);
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }
  private handlePublishStatusChange(index,row){
    console.log(row);
  }
  private handleCommentDetail(index,row){
		
	  // this.$router.push({path: '/Assess/comment',query:row})
  }
  private onSubmit() {
    console.log(this.form);
  }
}
